module.exports = __webpack_public_path__ + "static/image/history/pc/202405@3x.png?6ba772c2";